"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const file_upload_repository_1 = require("./file-upload.repository");
let FileUploadService = class FileUploadService {
    constructor(fileUploadRepository) {
        this.fileUploadRepository = fileUploadRepository;
    }
    /**
     * Uploads a file by delegating the file upload repository.
     */
    async uploadFile(file, companyType, companyId, documentTypeLid, userId) {
        try {
            if (!file) {
                throw new common_1.BadRequestException("File is required");
            }
            const result = await this.fileUploadRepository.uploadFile(file, companyType, companyId, documentTypeLid, userId);
            return result;
        }
        catch (error) {
            if (error instanceof common_1.BadRequestException) {
                throw error;
            }
            else {
                throw new common_1.NotFoundException("File upload failed");
            }
        }
    }
    async deleteFile(fileId, userId) {
        try {
            if (!fileId) {
                throw new common_1.BadRequestException("File ID is required");
            }
            const result = await this.fileUploadRepository.deleteFileFromServer(fileId, userId);
            if (result?.status !== common_1.HttpStatus.OK) {
                throw new common_1.InternalServerErrorException(result?.message || "File deletion failed");
            }
            return result;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw new common_1.NotFoundException(error.message);
            }
            if (error instanceof common_1.BadRequestException) {
                throw new common_1.BadRequestException(error.message);
            }
            throw new common_1.InternalServerErrorException("File deletion failed");
        }
    }
    async replaceFileFromServer(id, file, userId, body) {
        try {
            if (!id) {
                throw new common_1.BadRequestException("File ID is required");
            }
            return await this.fileUploadRepository.replaceFileFromServer(id, file, userId, body);
        }
        catch (error) {
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.BadRequestException(error instanceof Error
                    ? error.message
                    : "File replacement failed due to an unknown error");
        }
    }
    async download(documentId) {
        // Validation for required field
        if (!documentId || isNaN(Number(documentId))) {
            throw new common_1.BadRequestException("documentId is required and must be a valid number.");
        }
        const entry = await this.fileUploadRepository.findDocuments(documentId);
        if (!entry) {
            throw new common_1.NotFoundException("Document not found");
        }
        const extractFileName = (filePath) => {
            const parts = filePath.split("/");
            return parts[parts.length - 1];
        };
        const fileName = extractFileName(entry.fileKey);
        // Get the file stream and metadata (works for both S3 and local)
        const fileResult = await this.fileUploadRepository.getFileStream(entry.fileKey);
        // Validate fileResult and stream
        if (!fileResult || !fileResult.stream) {
            throw new common_1.NotFoundException("File not found in storage");
        }
        return {
            stream: fileResult.stream,
            fileName,
            mimeType: fileResult.mimeType || "application/octet-stream",
            contentLength: fileResult.contentLength,
        };
    }
};
exports.FileUploadService = FileUploadService;
exports.FileUploadService = FileUploadService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof file_upload_repository_1.FileUploadRepository !== "undefined" && file_upload_repository_1.FileUploadRepository) === "function" ? _a : Object])
], FileUploadService);
